import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
// 
import JNLogo from "../JNLogo";
import LandingCurrentDateTime from "../LandingCurrentDateTime";


const VerificationScreen = () => {
    // const [bgImageLoaded, setBgImageLoaded] = useState(true);
  
    //   useEffect(() => {
    //   const img = new Image();
    //   img.src = "/assets/images/bookonline-bg1.jpg";
    //   img.onload = () => setBgImageLoaded(true);
    //   img.onerror = () => setBgImageLoaded(false);
    // }, []);
  const navigate = useNavigate();
  const [referenceCode, setReferenceCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { decryptPayload} = require("../../utils/custom-hash");
 

  const handleChange = (e) => {
    setReferenceCode(e.target.value);
  };

  const handleProceed = async () => {
    try {
      if (!referenceCode) {
        setErrorMessage("Please enter your confirmation code.");
        return;
      }
        const response = await fetch(
            `${process.env.REACT_APP_ASERVER}/api/appointment/fetch/${referenceCode}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            if (response.status === 404) {
                throw new Error(errorData.message || "Reference code not found.");
            } else {
                throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
            }
        }

        const data = await response.json();
        
        if (data.status === "Cancelled") {
           
            setErrorMessage("Entered Confirmation Code is Cancelled");
        } else {
          const decrytData=decryptPayload(data.data)
          
            navigate("/ticket-details", {
                state: { responseData:decrytData},
            });
        }
    } catch (error) {
        setErrorMessage(error.message);
    }
};




  return (
    <section
      className="bg-half-170 d-table w-100"
      id="home"
      // style={{
        
      //   backgroundColor: "gray",
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      //   backgroundRepeat: "no-repeat",
      //   minHeight: "100vh",
      //   backgroundAttachment: 'fixed',
      //   paddingTop: '40px',
      // }}>
      style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(/assets/images/bookonline-bg.jpeg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          backgroundAttachment: "fixed",
          paddingTop: "30px",
          position: "relative",
        }}
    >
      <JNLogo />
    
      <LandingCurrentDateTime />

     <div className="bg-overlay-dark">

      <div className="container">
        <div className="row justify-content-center mt-5">
        <div className="col-md-5">
            
            </div>
        
          <div className="col-xl-7">
          <div className="card rounded text-center"  style={{backgroundColor:'rgba(255, 255, 255, 0.8)',
                  border:'1px solid #424242',
                  boxShadow:'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(184, 184, 184, 0.5) 2px 2px 32px 2px'
                  }}>
           
              <h4 className="heading fw-bold text-black title-dark mt-1 mb-2">
                Verify Your Appointment Details
              </h4>
              <p style={{color:'#000'}}>
              Please enter your confirmation code to confirm your appointment details.
              </p>
              <div className="heading-title text-center">
              <div className="mt-1 pt-1">
                <div className="rounded text-start shadow p-4 bg-black-50">
                  <div className="row align-items-center mb-2">
                  <div style={{ color: "red" }}>{errorMessage}</div>
                    <div className="col-md mb-3 mb-md-0">
                      <div className="input-group bg-white border rounded">
                        <input
                          type="text"
                          className="form-control border-0"
                          placeholder="Enter your confirmation code"
                          value={referenceCode}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-auto">
                      <div className="d-grid d-md-block">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleProceed}
                        >
                          Get Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default VerificationScreen;
